import fc from '@/firebaseConfig'

export default {
  namespaced: true,
  state: {
    list: [],
  },
  mutations: {
  },
  actions: {
  },
}
